import React, { Component } from 'react';
import BbButton from '@browsbox-ui/bb-button';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Languages extends Component {
  static propTypes = {
    languages: PropTypes.array.isRequired, // eslint-disable-line
  }

  static defaultProps = {
    languages: [],
  }

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const selectedLanguageCode = event.target.getAttribute('data-language');
    const selectedLanguage = this.props.languages.find(language => language.code === selectedLanguageCode);

    if (selectedLanguage.active === false) {
      if (selectedLanguage.default && selectedLanguage.default === true) {
        window.location.href = '/';
      } else {
        window.location.href = `/${selectedLanguage.code}`;
      }
    }
  }

  render() {
    return (
      <ul className="c-bb-languages">
        {
          this.props.languages.map((language) => {
            const classes = classNames(
              'c-bb-button--circle',
              { 'c-bb-button--inactive': !language.active },
            );

            return (
              <li key={language.code} className="c-bb-languages__item">
                <BbButton
                  key={language.code}
                  data-language={language.code}
                  onClick={this.onClick}
                  className={classes}
                  text={language.code}
                />
              </li>
            );
          })
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Languages/index.js